import { useSelector } from "react-redux";
import { useState } from "react";
import styles from "../../../../styles/Components/new-insight/create-strategy/CreateStrategyForm.module.css";
import { FaRegEdit } from "react-icons/fa";
import { Select } from "antd";
import { FaCircleCheck } from "react-icons/fa6";
import { IoIosCloseCircle } from "react-icons/io";
import { useStrategy } from "../useCreateStrategyContext";
const { Option } = Select;

function StrategyTag() {
  const {
    newInsightState: {
      createStrategyResult: { tags, strategy_tag: tag },
    },
  } = useSelector((state) => state);

  const [isEditing, setIsEditing] = useState(false);
  const [selectedTag, setSelectedTag] = useState([]);
  const {
    state: { strategyTag },
    setTag,
  } = useStrategy();

  console.log(strategyTag);

  return (
    <div className={styles.formItem}>
      <h5 className={styles.label}>Tag:</h5>
      <div className={`${styles.editBox}`}>
        <Select
          value={strategyTag}
          onChange={setTag}
          mode="multiple"
          placeholder="Select tag..."
        >
          {tags.map((suggestion, index) => (
            <Option key={index} value={suggestion}>
              {suggestion}
            </Option>
          ))}
        </Select>
      </div>

      {/*{!isEditing && (*/}
      {/*  <div className={styles.formInput}>*/}
      {/*    <span className={styles.value}>*/}
      {/*      {selectedTag?.length > 0*/}
      {/*        ? selectedTag?.join(", ")*/}
      {/*        : tag?.join(", ")}*/}
      {/*    </span>*/}
      {/*    <span*/}
      {/*      className={styles.edit}*/}
      {/*      onClick={() => {*/}
      {/*        setIsEditing(true);*/}
      {/*        setSelectedTag([tags?.[0]]);*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <FaRegEdit size={16} />*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*)}*/}

      {/*{isEditing && (*/}
      {/*  <div className={`${styles.editBox} ${styles.tagSelector}`}>*/}
      {/*    <Select value={selectedTag} onChange={setSelectedTag} mode="multiple">*/}
      {/*      {tags.map((suggestion, index) => (*/}
      {/*        <Option key={index} value={suggestion}>*/}
      {/*          {suggestion}*/}
      {/*        </Option>*/}
      {/*      ))}*/}
      {/*    </Select>*/}
      {/*    <span*/}
      {/*      className={styles.submitEdit}*/}
      {/*      onClick={() => setIsEditing(false)}*/}
      {/*    >*/}
      {/*      <FaCircleCheck size={18} />*/}
      {/*    </span>*/}
      {/*    <span*/}
      {/*      className={styles.closeEdit}*/}
      {/*      onClick={() => {*/}
      {/*        setSelectedTag([]);*/}
      {/*        setIsEditing(false);*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <IoIosCloseCircle size={22} />*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
}

export default StrategyTag;
